export default "__VITE_ASSET__DIWte6Io__"